import { z } from 'zod';
// 'document' = 변환(마크다운)해 LLM 이 읽는 비정형 문서 (pdf/hwp/hwpx/docx/pptx/md/txt).
//             엑셀처럼 SQL 임시테이블이 아니라 변환 텍스트 + doc.* 도구로 분석.
// 'image'    = image.generate 가 만든 생성 이미지 (MinIO 저장, /api/files/:id/content 로 서빙).
export const FileUploadKindSchema = z.enum(['excel', 'document', 'image', 'other']);
// 'uploading' = multipart 수신 중(문서 row-first). 'queued' = 변환 슬롯 대기. 'canceled' = 사용자/관리자 중지.
// 문서 lifecycle: uploading → queued → processing → ready/failed/canceled.
// 엑셀 lifecycle(기존): uploaded → processing → ready/failed.
export const FileUploadStatusSchema = z.enum([
    'uploading',
    'uploaded',
    'queued',
    'processing',
    'ready',
    'failed',
    'canceled',
]);
export const FileUploadSchema = z.object({
    id: z.string().uuid(),
    originalName: z.string(),
    mime: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    kind: FileUploadKindSchema,
    status: FileUploadStatusSchema,
    error: z.string().nullable(),
    createdAt: z.string(),
    readyAt: z.string().nullable(),
    /** MinIO PUT 단계 (multipart 파싱 + streamToStorage) 소요 ms. 옛 행은 null. */
    uploadMs: z.number().int().nonnegative().nullable(),
    /**
     * status='queued' 인 문서가 변환 시작 전까지 앞에 대기 중인 같은 사용자 작업 수.
     * 동시 변환 한도(per-user) 로 대기할 때 "대기 중 · 앞에 N건" 표시용. queued 가 아니면 null/생략.
     */
    queueAhead: z.number().int().nonnegative().nullable().optional(),
});
export const FileUploadListSchema = z.object({
    files: z.array(FileUploadSchema),
    /** 오브젝트 스토리지가 구성되어 있는지. false 면 업로드 불가 — UI 에서 버튼 비활성화. */
    storageReady: z.boolean(),
});
/** 업로드 허용 최대 바이트 — 서버/프런트 공통 상수. */
export const FILE_UPLOAD_MAX_BYTES = 500 * 1024 * 1024; // 500 MB
//# sourceMappingURL=files.js.map